import styled from 'styled-components'

export const MainContainer = styled.section``

export const HeaderContainer = styled.div`
    background-color: rgb(255, 255, 255);
    transition: all 200ms ease-out 0s;
    position: fixed;
    top: 0px;
    z-index: 100;
    width: 100vw;
    border-bottom: 1px solid #e0e0e0;
`
